<template>
  <div>
  <v-layout row>
    <v-flex sm10 offset-sm1 style="padding-top: 10px; min-height: 250px; overflow: visible; height: 250px;">
      <v-card color="white" flat>
        <v-card-text style="padding-top: 0px !important; padding-bottom: 0px !important;">
            <div style="font-size: 17px; overflow: hidden; white-space: nowrap;"> Application documents </div>
        </v-card-text>
      </v-card>
      <v-toolbar flat style="background-color: rgb(219, 219, 182); height: 57px;">
          <v-toolbar-items class="hidden-sm-and-down" v-if="applicationactivepage === 'submittedapplications'">
            <input id="fileinput" type="text" class="form-control" placeholder=" Choose file to upload..." :value="attachmentfilelist">
              <button id="fileselectbtn" class="btn btn-default" type="button" @click="launchFilePicker">
                <span id="filepaperclip" class="glyph ion-paperclip" aria-hidden="true"></span>
              </button>
            <input type="file" style="display:none" multiple="multiple" id="attachments" @change="uploadFieldChange" ref="file">
        </v-toolbar-items>
        <v-progress-linear
        v-if="applicationactivepage === 'submittedapplications'"
        style="margin-top: -7px; margin-left: 7px;"
          :indeterminate="false"
          :query="false"
          v-model="percentCompleted"
          :active="progressbarvisable"
        ></v-progress-linear>
    </v-toolbar>
      <v-card color="white" flat style="overflow-y: scroll; margin-right: 0px; height: 160px; border: 1px solid grey !important;">
        <div v-if="attachmentlist.length === 0">
          <br>
          <label style="padding-left: 20px;"> No files found </label>
        </div>
        <v-list-tile
          two-line
          style="border-bottom: 1px solid #dbdbb6; list-style-type: none;"
          v-for="(attachment, index) in attachmentlist" v-bind:key="index">

        <v-list-tile-content>
            <v-list-tile-title style="width: 310px;"><a v-bind:href="urlreadfile + attachment.name.replace(/\+/g,'%2B')"> {{ attachment.name }}</a></v-list-tile-title>
          <v-list-tile-sub-title style="width: 310px; color:grey; font-size: 11px;"> Uploaded by: {{ attachment.uploadedby }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-content>
            <v-list-tile-title style="padding-left: 10px; width: 100px;  font-size: 11px; color:grey" v-html="attachment.lastModifiedDate"></v-list-tile-title>
            <v-list-tile-sub-title style="padding-left: 10px; width: 100px; font-size: 11px; color: grey;" v-html="Number((attachment.size / 1024 ).toFixed(1)) + ' KB'"> </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-content>
            <v-list-tile-title @click="removeAttachment(attachment)">
              <button title="Delete" style="font-size: 20px; padding-right: 10px;" class="ion-trash-a" v-if="!readonly"> </button>
            </v-list-tile-title>
        </v-list-tile-content>
        </v-list-tile>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">Confirm</v-card-title>
        <v-card-text>Do you want to delete the file: <br><br> {{deletefile}} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="deleteattachmentfromserver()">Yes</v-btn>
          <v-btn color="green darken-1" flat @click.native="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  watch: {
    applicationid: function () {
      console.log('new application id: ' + this.applicationid)
      this.refreshattachmentlist()
    }
  },
  computed: {
    applicationid () {
      if (this.applicationactivepage === 'submittedapplications') {
        return this.$store.getters.getSelectedapplicationidsubmitted
      }
      if (this.applicationactivepage === 'pendingapplications') {
        return this.$store.getters.getSelectedapplicationidpending
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        return this.$store.getters.getSelectedapplicationidverified
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        return this.$store.getters.getSelectedapplicationidrejected
      }
      if (this.applicationactivepage === 'approvedapplications') {
        return this.$store.getters.getSelectedapplicationidapproved
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        return this.$store.getters.getSelectedapplicationidrejected
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        return this.$store.getters.getSelectedapplicationidcancelled
      }
    },
    urlreadfile () {
      return this.$store.getters.getBaseurl + 'attachedfiles/read?application_id=' + this.applicationid +
        '&token=' + this.$store.getters.gettoken + '&filename='
    },
    applicationactivepage () {
      console.log('application active page computed: ' + this.$store.getters.getApplicationactivepage)
      return this.$store.getters.getApplicationactivepage + ''
    },
    readonly () {
      let defaultvalue = true
      if (this.applicationactivepage === 'submittedapplications') {
        if ((this.$store.getters.getUsertype === 'user') || (this.$store.getters.getUsertype === 'admin')) {
          defaultvalue = false
        }
      }
      return defaultvalue
    }
  },
  data () {
    return {
      attachmentlist: [],
      dialog: false,
      file: '',
      deletefile: '',
      attachments: [],
      attachmentfilelist: '',
      data: new FormData(),
      percentCompleted: 0,
      progressbarvisable: false,

      // Config for axios header
      config: {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken },
        onUploadProgress: function (progressEvent) {
          this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log('completed' + this.percentCompleted)
        }.bind(this)
      }
    }
  },
  methods: {
    refreshattachmentlist () {
      let tempapplicationlist = []
      if (this.applicationactivepage === 'submittedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistsubmitted
      }
      if (this.applicationactivepage === 'pendingapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistpending
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistverified
      }
      if (this.applicationactivepage === 'approvedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistapproved
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistrejected
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistrejected
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistcancelled
      }
      try {
        if (typeof tempapplicationlist[this.applicationid] === 'undefined') {
          this.attachmentlist = []
        } else {
          this.attachmentlist = tempapplicationlist[this.applicationid].attachments
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    },
    // Launch the file picket for uploading attachments
    launchFilePicker () {
      this.$refs.file.click()
    },
    // Validate if file were selected for upload attachments
    validate () {
      if (!this.attachments.length) {
        this.$toastr.warning('Please add files', 'Warning')
        return false
      }
      return true
    },
    // Prepare the correct format for uploading files
    prepareFields () {
      for (var i = this.attachments.length - 1; i >= 0; i--) {
        this.data.append('attachments[]', this.attachments[i])
        this.attachmentfilelist = this.attachmentfilelist + '/' + this.attachments[i].name
      }
      this.data.append('category_id', '2')
      this.data.append('application_id', this.applicationid)
    },
    // Popup dialog to confirm delete attachements
    removeAttachment (attachment) {
      this.deletefile = attachment.name
      console.log('remove attachment dialog' + attachment.name)
      this.dialog = true
    },
    // This function will be called every time you add a file
    uploadFieldChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      for (var i = files.length - 1; i >= 0; i--) {
        console.log('files:' + files[i])
        this.attachments.push(files[i])
      }
      this.submit()
    },
    // Start uploading the attachments
    submit () {
      this.prepareFields()
      if (!this.validate()) {
        return false
      }
      this.sendfile()
    },
    // Start the upload attachements progress bar
    loading () {
      console.log('loading the file bar')
      this.progressbarvisable = false
    },
    // Logout and go to the front-page when repy code is 401 for call to the server
    logout () {
      this.$store.dispatch('logout')
      this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
      this.$router.push({
        name: 'frontpage'
      })
    },
    fetchApplicationlist: function () {
      this.$store.dispatch('fetchApplicationslistsubmitted').then(response => {
        console.log('get attachment list')
        this.attachmentlist = this.$store.getters.getApplicationslistsubmitted[this.applicationid].attachments
      }, error => {
        console.log('error: ' + error)
        console.log('get attachment list fail')
        this.$toastr('Errors', 'Could not load the applications from the server', 'Error')
      })
    },
    async sendfile () {
      try {
        this.progressbarvisable = true
        const response = await Api().post('attachedfiles/create', this.data, this.config)
        if (response.status) {
          this.$toastr('success', 'Documents uploaded!', 'Success')
          this.$store.dispatch('fetchApplicationslistsubmitted').then(response => {
            // this.fetchApplicationlist()
            this.attachmentlist = this.$store.getters.getApplicationslistsubmitted[this.applicationid].attachments
          }).catch(error => {
            console.log('send file error1:' + error)
            this.$toastr('Errors', 'Could not get the files from the server', 'Error')
          })
          this.resetData()
          setTimeout(this.loading, 700)
        } else {
          this.$toastr('error', 'Something went wrong!', 'Error')
          setTimeout(this.loading, 700)
        }
        setTimeout(this.loading, 700)
      } catch (e) {
        console.log('send file error:' + e)
        if (e.response.status === 401) {
          this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
          this.logout()
        } else {
          this.$toastr('error', 'There was an error uploding the files, please try again!', 'Error upload')
          this.resetData()
        }
        setTimeout(this.loading, 700)
      }
    },
    // Delete attachment call to the FileService
    async deleteattachmentfromserver () {
      this.dialog = false
      try {
        const response = await Api().delete('attachedfiles/delete', {
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken },
          params: {'filename': this.deletefile, 'application_id': this.applicationid}
        })
        if (response) {
          if (response.data.status === 'Success') {
            this.$toastr('success', 'File deleted', 'Success')
            this.fetchApplicationlist()
            this.resetData()
          } else {
            this.$toastr('error', 'Could not delete the file: ' + response.data.errors, 'Error')
          }
        } else {
          this.$toastr('error', 'Could not delete the file.', 'Error')
        }
      } catch (e) {
        console.log('delete file error:' + e)
      }
    },
    // We want to clear the FormData object on every upload so we can re-calculate new files again.
    resetData () {
      this.data = new FormData() // Reset it completely
      this.attachments = []
      this.attachmentfilelist = ''
    }
  },
  mounted () {
    this.refreshattachmentlist()
  }
}
</script>

<style scoped>
@import '@../../../assets/css/ionicons.min.css';

#fileinput {
  width: 170px;
  height: 25px;
  border: 1px solid black;
  border-top-left-radius: .3rem;
  border-bottom-left-radius: .3rem;
  background-color: lightgrey;
  font-size: 12px;
}
#fileselectbtn {
  min-width: 30px;
  height:25px;
  padding: 0 0 0 0;
  border: 1px solid black;
  border-top-right-radius: .3rem;
  border-bottom-right-radius: .3rem;
  background-color: white;
  margin-left: -1px;
  margin-top: 0px;
}
#filepaperclip {
  font-size:24px;
  transform: rotate(45deg);
  vertical-align: top !important;
  display: flex;
  background-color: white;
}
.list__tile__title{
  font-size: 13px;
}
.list__tile__sub-title{
  font-size: 13px;
}
.list__tile{
  padding-right: 1px !important;
  height: 20px !important;
}
.toolbar{
  border-top: 1px black solid;
  border-left: 1px black solid;
  border-right: 1px black solid;
}
.hidden-sm-and-down{
  padding-top: 15px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Applicationattachments.vue